"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCollectionStencil = exports.collectionStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.collectionStencilDefinition = {
    view: {
        label: 'Pseudogroup',
        category: 'tag',
        group: 'Taxonomy',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'preferred-label',
                            'type-of-collection',
                            'seo-title',
                            'social-title',
                            'uri-title',
                            'alternative-labels',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['broader-collection', 'related-content'],
            },
        ],
    },
    content: {
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'type-of-collection': properties_1.typeOfCollectionPropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
        'alternative-labels': properties_1.alternativeLabelsPropertyDefinition,
        'broader-collection': properties_1.broaderCollectionPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
    },
    localizations: ['en'],
    roles: ['taxonomy-manager'],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'speedweek',
        'wingfinder',
    ],
    name: 'collection',
};
const isCollectionStencil = (stencil) => {
    return stencil.name === exports.collectionStencilDefinition.name;
};
exports.isCollectionStencil = isCollectionStencil;
//# sourceMappingURL=data:application/json;base64,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